import type { BatteryTone } from '../../lib/batteryLife';

interface StatusPillProps {
  tone: BatteryTone;
  label: string;
  className?: string;
}

const TONE_CLASS: Record<BatteryTone, string> = {
  healthy: 'badge-healthy',
  warning: 'badge-warning',
  critical: 'badge-critical',
};

export function StatusPill({ tone, label, className = '' }: StatusPillProps) {
  return (
    <span className={`${TONE_CLASS[tone]} ${className}`}>
      <span
        className={`w-1.5 h-1.5 rounded-full ${
          tone === 'healthy' ? 'bg-lime-400' : tone === 'warning' ? 'bg-accent-orange' : 'bg-accent-red'
        }`}
        aria-hidden="true"
      />
      {label}
    </span>
  );
}
